import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  SendContactFormRequest,
  SendContactFormResponse,
} from "@/api/types/contactForm";

export async function sendContactForm(
  request: SendContactFormRequest
): Promise<SendContactFormResponse> {
  const { data, error } = await supabase.functions.invoke("api/contact", {
    method: "POST",
    body: request,
  });

  await handleSupabaseFunctionError(error);

  if (!data || typeof data.success !== "boolean") {
    throw new Error("Invalid response format from contact endpoint");
  }

  return data;
}
